// Keep the full sample available without JavaScript; start compact offers closed.
function enhancePurchaseOfferPreview(dialog, windowObject) {
    const preview = dialog.querySelector('[data-am-offer-preview]');
    if (!preview || typeof windowObject?.matchMedia !== 'function') return;

    const compact = windowObject.matchMedia('(max-width: 47.999rem)');
    const update = () => { preview.open = !compact.matches; };
    update();
    compact.addEventListener('change', update);
}

function resetPurchaseOfferScroll(dialog) {
    dialog.scrollTop = 0;
    const content = dialog.querySelector?.('.am-pdf-offer__layout');
    if (content) content.scrollTop = 0;
}

module.exports = {enhancePurchaseOfferPreview, resetPurchaseOfferScroll};
